import swal from "sweetalert2";
import React, { createContext, useState } from 'react';

const AppContext = createContext();

const AppProvider = ({ children }) => {

  const [user, setUser] = useState(() => {
    const user = localStorage.getItem('v2a-admin-auth')
    return user ? JSON.parse(user) : null;
  });

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = localStorage.getItem('v2a-admin-auth-token');
    return !!token;
  });
  
  const login = (token,userData) => {
    console.log("logging in......")
    localStorage.setItem('v2a-admin-auth-token',token);
    localStorage.setItem('v2a-admin-auth',JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };
  const logout = async () => {
    console.log("logging out......")
    await swal.fire({
      title: "Log Out",
      text: "Are you sure you want to log out ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: {
        actions: 'my-swal-actions'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear()
        setIsAuthenticated(false);
        setUser(null); 
      }
    });
  };

  return (
    <AppContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
